const DOT_COLORS = ["#5DCAA5", "#AFA9EC", "#B4B2A9", "#F0997B", "#85B7EB"];

export default function LineageResponse({ data }) {
  if (!data) return null;
  const { source, data: consumers = [], direction = "downstream" } = data;

  return (
    <div className="mt-2 w-full flex flex-col gap-0">
      {/* Source node */}
      <div className="bg-gray-50 border border-gray-200 rounded-xl px-4 py-3">
        <div className="font-mono text-[13px] font-medium text-gray-800">
          {source?.name}
        </div>
        <div className="text-[12px] text-gray-400 mt-0.5">
          Source · {source?.meta}
        </div>
      </div>

      {/* Arrow label */}
      <div className="flex items-center justify-center gap-1.5 py-2.5 text-[12px] text-gray-400">
        <span>{direction === "downstream" ? "↓" : "↑"}</span>
        <span>{direction} consumers</span>
      </div>

      {/* Consumer cards */}
      <div className="flex flex-col gap-2">
        {consumers.map((c, i) => {
          const color = DOT_COLORS[i % DOT_COLORS.length];
          return (
            <div key={i} className="bg-white border border-gray-200 rounded-xl px-4 py-3 flex items-start gap-3">
              <div
                className="w-7 h-7 rounded-lg shrink-0 mt-0.5 border-2"
                style={{ background: `${color}22`, borderColor: color }}
              />
              <div className="flex-1 min-w-0">
                <div className="font-mono text-[13px] font-medium text-blue-600">
                  {c.title}  
                </div>
                <div className="text-[12px] text-gray-400 mt-0.5">
                  {c.meta}
                </div>
                <div className="text-[12px] text-gray-500 mt-1">
                  {c.description}  
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}